const SHOWED_UPSELLING_DEALS_MODAL = 'showed_upselling_deals_modal';

const LAYOUT_MODE_KEY = 'chekin-layout';
const PREVIOUS_PAGE_STORAGE_KEY = 'chekin-previous-page';
const SHOWED_GUEST_GROUP_MODAL = 'showed_guest_group_modal';
const SHOWED_SUCCESS_REGISTER_COMPLETE_MODAL =
  'showed_success_register_complete_complete';
import {
  EMAIL_SHARE_LINK,
  IS_LEADER_GUEST_STORAGE_KEY,
  SIGNATURES_QUALITY,
  SMS_SHARE_LINK,
  WHATSAPP_SHARE_LINK,
} from '@chekin/shared/guest-form';

enum STORAGE_KEYS {
  personalFormData = 'PERSONAL_FORM_DATA',
  ivScannedData = 'IV_SCANNED_DATA',
  ivScannedGuestId = 'IV_SCANNED_GUEST_ID',
  personalSignatureFormData = 'PERSONAL_SIGNATURE_FORM_DATA',
  ivIntentRemoteSession = 'IV_INTENT_REMOTE_SESSION',
}

enum STATUSES {
  loading = 'loading',
  error = 'error',
  success = 'success',
  idle = 'idle',
}

const TRUSTED_OAUTH_ORIGINS = [
  window.location.origin,
  'https://guestapp-v2.stg.chekin.com',
  'https://guest.chekin.com',
  ...(import.meta.env.DEV ? ['http://localhost:3000', 'http://localhost:3001'] : []),
];

export {
  TRUSTED_OAUTH_ORIGINS,
  STORAGE_KEYS,
  SIGNATURES_QUALITY,
  STATUSES,
  WHATSAPP_SHARE_LINK,
  SMS_SHARE_LINK,
  EMAIL_SHARE_LINK,
  SHOWED_GUEST_GROUP_MODAL,
  SHOWED_SUCCESS_REGISTER_COMPLETE_MODAL,
  PREVIOUS_PAGE_STORAGE_KEY,
  IS_LEADER_GUEST_STORAGE_KEY,
  SHOWED_UPSELLING_DEALS_MODAL,
  LAYOUT_MODE_KEY,
};
